import React from "react";
import {Container} from "react-bootstrap";
import HorsesHooves from "./zhuangzi/HorsesHooves";
import LordOfTheCenter from "./zhuangzi/LordOfTheCenter";
import ChillFogLights from "./qinguan/ChillFogLights";
import TheLybianSerpents from "./lucan/TheLybianSerpents";
import TheAmphisbaena from "./borges/TheAmphisbaena";

function Translation() {
    return (
        <Container>
            <TheLybianSerpents />
            <hr />
            <TheAmphisbaena />
            <hr />
            <ChillFogLights />
            <hr />
            <HorsesHooves />
            <hr />
            <LordOfTheCenter />
        </Container>
    )
}

export default Translation;
